import script from "./UiLightButton.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./UiLightButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiLightButton.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./UiLightButton.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__